import Viewport from "./viewport.js";

export default class Factory {
    static make() {
        return new this();
    }
    viewport() {
        return new Viewport(this);
    }
}
